import { TFunction } from 'i18next';
import { routes } from '../../../constants';

const getCollectionTabs = (t: TFunction) => ({
  pinned: {
    id: routes.pinned.root,
    label: t('Pinned Documents')
  },
  ownCollections: {
    id: routes.collections.root,
    label: t('My Collections')
  },
  followedCollections: {
    id: routes.followed.root,
    label: t('Followed Collections')
  }
});

export default getCollectionTabs;
